<template>
    <div class=" my-8 text-center text-orange-600 text-3xl md:text-5xl">
        <router-link to="features">
            explore the features
            <i class="fas fa-chevron-right" data-fa-transform="down-2"></i>
        </router-link>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
